/* ============================================================
   BRO CROSS-SELL v5.3 — Bromotors.fr — Broadcast
   FIX: cherche le bon module dans le drawer actif
   ============================================================ */
(function () {
  'use strict';

  var THRESHOLD = 7500;
  var HIGH_CART = 6000;
  var MIN_GAP = 50;
  var PAGE_SIZE_DEFAULT = 3;
  var PAGE_SIZE_SMALL = 2;
  var CART_ITEMS_THRESHOLD = 3;
  var ROTATION_DELAY = 8000;
  var SESSION_KEY = 'bro_cs_dismissed';

  var GOODIES_CATS = { stickers: true, accessoires: true };
  var CROSS_MAP = { vetements: 'bagagerie', bagagerie: 'vetements' };

  var TYPE_MAP = {
    'sweat':'vetements','sweats':'vetements','sweatshirt':'vetements',
    't-shirt':'vetements','tshirt':'vetements','tee-shirt':'vetements',
    'hoodie':'vetements','veste':'vetements','jacket':'vetements',
    'pantalon':'vetements','jean':'vetements','vetement':'vetements',
    'vetements':'vetements','sac':'bagagerie','sac à dos':'bagagerie',
    'sacoche':'bagagerie','bag':'bagagerie','backpack':'bagagerie',
    'bagagerie':'bagagerie','banane':'bagagerie',
    'bonnet':'accessoires','casquette':'accessoires','gant':'accessoires',
    'gants':'accessoires','accessoire':'accessoires','accessoires':'accessoires',
    'tour de cou':'accessoires','porte-clés':'accessoires','porte-cles':'accessoires',
    'bracelet':'accessoires','microfibre':'accessoires',
    'sticker':'stickers','stickers':'stickers','autocollant':'stickers','autocollants':'stickers'
  };

  var filtered = [];
  var currentPage = 0;
  var totalPages = 0;
  var pageSize = PAGE_SIZE_DEFAULT;
  var rotTimer = null;
  var addingToCart = false;
  var lastRemaining = 0;
  var lastMode = 'shipping';
  var cachedPool = [];

  function log() {}

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + '\u20AC'; }

  function loadDismissed() {
    try { return new Set(JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]')); }
    catch (e) { return new Set(); }
  }

  function catOf(p) {
    if (p.category && p.category.trim()) return p.category.trim().toLowerCase();
    if (Array.isArray(p.tags)) {
      for (var i = 0; i < p.tags.length; i++) {
        var t = p.tags[i].toLowerCase().trim();
        if (t === 'vetements' || t === 'bagagerie' || t === 'accessoires' || t === 'stickers') return t;
      }
    }
    if (p.type) { var m = TYPE_MAP[p.type.toLowerCase().trim()]; if (m) return m; }
    return 'unknown';
  }

  function isGoody(p) { return GOODIES_CATS[catOf(p)] === true; }

  /* ---- FIND THE RIGHT MODULE ----
     Broadcast peut laisser des fragments dans le DOM.
     On cherche TOUS les #bro-cross-sell et on prend celui
     qui est dans le drawer connecté au document. */
  function findModule() {
    var all = document.querySelectorAll('#bro-cross-sell');
    log('findModule: found', all.length, 'module(s) in DOM');

    if (all.length === 0) return null;
    if (all.length === 1) return all[0];

    /* Plusieurs modules → prendre celui qui est dans le drawer visible
       ou dans [data-checkout-buttons], ou le dernier dans le DOM */
    for (var i = all.length - 1; i >= 0; i--) {
      var el = all[i];
      /* Vérifier qu'il est connecté au document */
      if (!document.body.contains(el)) continue;
      /* Préférer celui dans le cart-drawer */
      if (el.closest('#cart-drawer') || el.closest('[data-cart-drawer-inner]')) return el;
      /* Ou celui dans la page cart */
      if (el.closest('[data-checkout-buttons]') || el.closest('form[action="/cart"]')) return el;
    }

    /* Fallback: le dernier connecté */
    for (var j = all.length - 1; j >= 0; j--) {
      if (document.body.contains(all[j])) return all[j];
    }

    return all[all.length - 1];
  }

  /* ---- READ POOL ---- */
  function getPool() {
    var m = findModule();
    if (m) {
      var raw = m.getAttribute('data-pool');
      if (raw) {
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            cachedPool = parsed.filter(Boolean);
            return cachedPool;
          }
        } catch (e) {}
      }
    }
    if (window.__broCSPool && window.__broCSPool.length > 0) { cachedPool = window.__broCSPool; return cachedPool; }
    return cachedPool;
  }

  /* ---- READ PRIORITY IDS from metafields ---- */
  var cachedPriorityIds = [];
  function getPriorityIds() {
    var m = findModule();
    if (m) {
      var raw = m.getAttribute('data-priority-ids');
      if (raw && raw.trim()) {
        cachedPriorityIds = raw.split(',').map(function (id) { return parseInt(id.trim(), 10); }).filter(function (id) { return !isNaN(id); });
        return cachedPriorityIds;
      }
    }
    return cachedPriorityIds;
  }

  /* ---- FILTER ---- */
  function filterPool(pool, remaining, total, cartCats, cartIds) {
    var dis = loadDismissed();
    var freeShipping = remaining <= 0;

    var base = pool.filter(function (p) {
      if (cartIds.has(p.id)) return false;
      if (dis.has(p.id)) return false;
      return true;
    });
    if (base.length === 0) base = pool.filter(function (p) { return !cartIds.has(p.id); });
    if (base.length === 0) return [];

    if (freeShipping) {
      lastMode = 'goodies';
      var goodies = base.filter(function (p) { return isGoody(p); });
      goodies.sort(function (a, b) { return a.price - b.price; });
      if (goodies.length === 0) { goodies = base.slice(); goodies.sort(function (a, b) { return a.price - b.price; }); }
      log('MODE GOODIES →', goodies.length);
      return goodies.slice(0, 12);
    }

    lastMode = 'shipping';
    var targetCats = new Set();
    cartCats.forEach(function (cat) { if (CROSS_MAP[cat]) targetCats.add(CROSS_MAP[cat]); });
    targetCats.add('stickers'); targetCats.add('accessoires');
    var hasMainCross = false;
    cartCats.forEach(function (cat) { if (CROSS_MAP[cat]) hasMainCross = true; });
    if (!hasMainCross) { targetCats.add('vetements'); targetCats.add('bagagerie'); }

    var candidates = base.filter(function (p) {
      var c = catOf(p);
      return targetCats.has(c) || c === 'unknown' || GOODIES_CATS[c];
    });
    if (candidates.length < pageSize) candidates = base.slice();

    if (total >= HIGH_CART) {
      candidates.sort(function (a, b) {
        var aG = isGoody(a) ? 1 : 0, bG = isGoody(b) ? 1 : 0;
        if (aG !== bG) return bG - aG;
        var aC = a.price >= remaining ? 1 : 0, bC = b.price >= remaining ? 1 : 0;
        if (aC !== bC) return bC - aC;
        return Math.abs(a.price - remaining) - Math.abs(b.price - remaining);
      });
    } else {
      candidates.sort(function (a, b) {
        var aCat = catOf(a), bCat = catOf(b);
        var aCr = (!GOODIES_CATS[aCat] && targetCats.has(aCat)) ? 1 : 0;
        var bCr = (!GOODIES_CATS[bCat] && targetCats.has(bCat)) ? 1 : 0;
        if (aCr !== bCr) return bCr - aCr;
        var aC = a.price >= remaining ? 1 : 0, bC = b.price >= remaining ? 1 : 0;
        if (aC !== bC) return bC - aC;
        return b.price - a.price;
      });
    }

    log('MODE SHIPPING →', candidates.slice(0, 12).length);
    return candidates.slice(0, 12);
  }

  function getPageProducts() { return filtered.slice(currentPage * pageSize, currentPage * pageSize + pageSize); }

  function buildCardHTML(product, delayIdx) {
    var hasComp = product.compare_price && product.compare_price > product.price;
    var disc = hasComp ? Math.round((1 - product.price / product.compare_price) * 100) : 0;
    var priceHTML = hasComp
      ? '<span class="bro-cs__price">' + fmt(product.price) + '</span><span class="bro-cs__compare-price">' + fmt(product.compare_price) + '</span><span class="bro-cs__tag">-' + disc + '%</span>'
      : '<span class="bro-cs__price">' + fmt(product.price) + '</span>';
    return '<div class="bro-cs__card bro-cs__card--stagger" style="animation-delay:' + (delayIdx * 80) + 'ms" data-product-id="' + product.id + '">' +
      '<a href="' + product.url + '" class="bro-cs__img-wrap"><img class="bro-cs__img" src="' + product.image + '" alt="' + product.title + '" loading="lazy" width="52" height="52"></a>' +
      '<div class="bro-cs__info"><p class="bro-cs__product-name">' + product.title + '</p><div class="bro-cs__product-meta">' + priceHTML + '</div></div>' +
      '<button class="bro-cs__add-btn' + (product.has_variants ? ' bro-cs__add-btn--choose' : '') + '" type="button" data-variant-id="' + product.variant_id + '" data-product-handle="' + (product.handle || '') + '" data-has-variants="' + (product.has_variants ? 'true' : 'false') + '"><span class="bro-cs__add-icon">' + (product.has_variants ? '→' : '+') + '</span><span class="bro-cs__add-label">' + (product.has_variants ? 'Choisir' : 'Ajouter') + '</span></button></div>';
  }

  function renderPage(container, direction) {
    var products = getPageProducts();
    if (products.length === 0) return;
    var html = '';
    for (var i = 0; i < products.length; i++) html += buildCardHTML(products[i], i);
    var oldCards = container.querySelectorAll('.bro-cs__card');
    if (oldCards.length > 0 && direction) {
      var cls = direction === 'left' ? 'bro-cs__card--exit-left' : 'bro-cs__card--exit-right';
      for (var j = 0; j < oldCards.length; j++) oldCards[j].classList.add(cls);
      setTimeout(function () { container.innerHTML = html; bindCardButtons(container); }, 250);
    } else {
      container.innerHTML = html;
      bindCardButtons(container);
    }
  }

  function bindCardButtons(container) {
    var btns = container.querySelectorAll('.bro-cs__add-btn');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var hv = btn.getAttribute('data-has-variants') === 'true';
          var handle = btn.getAttribute('data-product-handle');
          var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (hv && handle) { triggerQuickAdd(handle); return; }
          var card = btn.closest('.bro-cs__card');
          var pid = card ? parseInt(card.getAttribute('data-product-id'), 10) : 0;
          var product = null;
          for (var f = 0; f < filtered.length; f++) { if (filtered[f].id === pid) { product = filtered[f]; break; } }
          doAdd(vid, btn, product);
        });
      })(btns[i]);
    }
  }

  function triggerQuickAdd(handle) {
    var existing = document.querySelector('[data-quick-add-modal-handle="' + handle + '"]');
    if (existing) { existing.click(); return; }
    fetch('/products/' + handle + '?section_id=api-product-grid-item', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var qaBtn = doc.querySelector('[data-quick-add-modal-handle="' + handle + '"]') || doc.querySelector('[data-quick-add-btn]');
        if (qaBtn) {
          var w = document.createElement('div'); w.style.display = 'none';
          var qa = doc.querySelector('quick-add-product');
          w.innerHTML = qa ? qa.outerHTML : '';
          if (w.innerHTML) { document.body.appendChild(w); var b = w.querySelector('[data-quick-add-modal-handle], [data-quick-add-btn]'); if (b) { b.click(); setTimeout(function () { w.remove(); }, 2000); return; } }
        }
        window.location.href = '/products/' + handle;
      }).catch(function () { window.location.href = '/products/' + handle; });
  }

  function doAdd(variantId, btn, product) {
    if (addingToCart) return;
    addingToCart = true;
    btn.classList.add('bro-cs__add-btn--loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_Ajouté via': 'Cross-sell panier' } }] }) })
    .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw d; }); return r.json(); })
    .then(function () {
      btn.classList.remove('bro-cs__add-btn--loading');
      btn.classList.add('bro-cs__add-btn--success');
      addingToCart = false;
      if (document.querySelector('[data-cart-page]')) { setTimeout(function () { window.location.reload(); }, 400); return; }
      var isPromo = product && product.compare_price && product.compare_price > product.price;
      if (isPromo) { try { sessionStorage.setItem('bro_reopen_drawer', '1'); } catch (e) {} setTimeout(function () { window.location.reload(); }, 400); }
      else {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.openCartDrawer === 'function') { try { cd.openCartDrawer(); } catch (e) { window.location.reload(); } }
        else { setTimeout(function () { window.location.reload(); }, 400); }
        setTimeout(function () { schedule(200); }, 500);
        setTimeout(function () { schedule(200); }, 1000);
        setTimeout(function () { schedule(200); }, 1500);
      }
    })
    .catch(function (err) {
      console.error('[BroCS] Erreur ajout:', JSON.stringify(err));
      btn.classList.remove('bro-cs__add-btn--loading');
      btn.innerHTML = '<span class="bro-cs__add-icon">!</span><span class="bro-cs__add-label">Erreur</span>';
      setTimeout(function () { btn.innerHTML = '<span class="bro-cs__add-icon">+</span><span class="bro-cs__add-label">Ajouter</span>'; }, 2000);
      addingToCart = false;
    });
  }

  function startRot() { stopRot(); if (totalPages <= 1) return; rotTimer = setInterval(doRotate, ROTATION_DELAY); }
  function stopRot() { if (rotTimer) { clearInterval(rotTimer); rotTimer = null; } }
  function doRotate() { if (totalPages <= 1) return; currentPage = (currentPage + 1) % totalPages; showPage('left'); }

  function showPage(direction) {
    var m = findModule(); if (!m) return;
    var cont = m.querySelector('.bro-cs__products'); if (!cont) return;
    renderPage(cont, direction); renderNav(m); renderDots(m);
  }

  function goTo(direction) {
    if (totalPages <= 1) return; stopRot();
    currentPage = direction === 'next' ? (currentPage + 1) % totalPages : (currentPage - 1 + totalPages) % totalPages;
    showPage(direction === 'next' ? 'left' : 'right'); startRot();
  }

  function renderNav(m) {
    var z = m.querySelector('.bro-cs__nav'); if (!z) return;
    if (totalPages <= 1) { z.classList.add('bro-cs__nav--hidden'); return; }
    z.classList.remove('bro-cs__nav--hidden');
    z.innerHTML = '<button type="button" class="bro-cs__nav-btn bro-cs__nav-prev" aria-label="Précédent">\u2039</button><span class="bro-cs__nav-counter"><span class="bro-cs__nav-current">' + String(currentPage + 1).padStart(2, '0') + '</span><span class="bro-cs__nav-sep">—</span><span class="bro-cs__nav-total">' + String(totalPages).padStart(2, '0') + '</span></span><button type="button" class="bro-cs__nav-btn bro-cs__nav-next" aria-label="Suivant">\u203A</button>';
    z.querySelector('.bro-cs__nav-prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo('prev'); });
    z.querySelector('.bro-cs__nav-next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo('next'); });
  }

  function renderDots(m) {
    var z = m.querySelector('.bro-cs__dots'); if (!z) return;
    if (totalPages <= 1) { z.innerHTML = ''; return; }
    var h = ''; for (var i = 0; i < totalPages; i++) h += '<span class="bro-cs__dot' + (i === currentPage ? ' bro-cs__dot--active' : '') + '"></span>';
    z.innerHTML = h;
  }

  function initSwipe(m) {
    if (m.__broSwipeInit) return; m.__broSwipeInit = true;
    var sx = 0, sy = 0, tr = false;
    m.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; tr = true; stopRot(); }, { passive: true });
    m.addEventListener('touchmove', function () {}, { passive: true });
    m.addEventListener('touchend', function (e) {
      if (!tr) return; tr = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? goTo('next') : goTo('prev'); }
      setTimeout(function () { if (totalPages > 1) startRot(); }, 3000);
    }, { passive: true });
  }

  function updateHeader(m, mode) {
    var t = m.querySelector('.bro-cs__title'), u = m.querySelector('.bro-cs__urgency');
    if (mode === 'goodies') {
      if (t) t.innerHTML = '<span class="bro-cs__title-highlight">COMPLÈTE</span> TA COMMANDE';
      if (u) u.innerHTML = '⚡ EXTRAS';
    } else {
      if (t) t.innerHTML = '<span class="bro-cs__title-highlight">LIVRAISON OFFERTE</span> — ON T\'AIDE';
      if (u) u.innerHTML = '🔥 LIMITÉ';
    }
  }

  /* ---- MAIN ---- */
  function update() {
    if (addingToCart) return;

    var pool = getPool();
    if (!pool || pool.length === 0) { log('No pool → abort'); return; }

    fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var total = cart.total_price, remaining = THRESHOLD - total;
      lastRemaining = remaining;

      log('Cart: total=' + total, 'remaining=' + remaining, 'items=' + cart.items.length);

      var m = findModule();

      if (!cart.items || cart.items.length === 0) {
        if (m) { m.style.display = 'none'; m.removeAttribute('data-visible'); }
        stopRot(); return;
      }

      if (remaining > 0 && remaining < MIN_GAP) {
        if (m) { m.style.display = 'none'; m.removeAttribute('data-visible'); }
        stopRot(); return;
      }

      /* Adapter le nombre de produits affichés selon le nombre de line items */
      pageSize = cart.items.length >= CART_ITEMS_THRESHOLD ? PAGE_SIZE_SMALL : PAGE_SIZE_DEFAULT;

      var cartCats = new Set(), cartIds = new Set();
      var poolIdx = {}; for (var pi = 0; pi < pool.length; pi++) poolIdx[pool[pi].id] = pool[pi];

      for (var i = 0; i < cart.items.length; i++) {
        var pid = cart.items[i].product_id; cartIds.add(pid);
        if (poolIdx[pid]) { var pc = catOf(poolIdx[pid]); if (pc !== 'unknown') { cartCats.add(pc); continue; } }
        if (cart.items[i].product_type) { var mp = TYPE_MAP[cart.items[i].product_type.toLowerCase().trim()]; if (mp) { cartCats.add(mp); continue; } }
        var ti = (cart.items[i].title || '').toLowerCase();
        if (ti.indexOf('sweat') !== -1 || ti.indexOf('shirt') !== -1 || ti.indexOf('hoodie') !== -1 || ti.indexOf('veste') !== -1) cartCats.add('vetements');
        else if (ti.indexOf('sac') !== -1 || ti.indexOf('sacoche') !== -1 || ti.indexOf('banane') !== -1) cartCats.add('bagagerie');
        else if (ti.indexOf('sticker') !== -1 || ti.indexOf('ecusson') !== -1 || ti.indexOf('écusson') !== -1) cartCats.add('stickers');
        else if (ti.indexOf('porte-cl') !== -1 || ti.indexOf('bracelet') !== -1 || ti.indexOf('microfibre') !== -1 || ti.indexOf('casquette') !== -1 || ti.indexOf('bonnet') !== -1) cartCats.add('accessoires');
      }

      filtered = filterPool(pool, remaining, total, cartCats, cartIds);

      /* ---- PRIORITY PRODUCTS (metafields) ---- */
      var priorityIds = getPriorityIds();
      if (priorityIds.length > 0) {
        /* Trouver les produits prioritaires dans le pool (pas déjà dans le panier) */
        var prioritySet = new Set(priorityIds);
        var priorityProducts = [];
        var seenPriority = new Set();

        for (var pi2 = 0; pi2 < priorityIds.length; pi2++) {
          if (cartIds.has(priorityIds[pi2])) continue;
          if (seenPriority.has(priorityIds[pi2])) continue;
          for (var pp = 0; pp < pool.length; pp++) {
            if (pool[pp].id === priorityIds[pi2]) {
              priorityProducts.push(pool[pp]);
              seenPriority.add(priorityIds[pi2]);
              break;
            }
          }
        }

        if (priorityProducts.length > 0) {
          /* Retirer les produits prioritaires du résultat auto pour éviter les doublons */
          filtered = filtered.filter(function (p) { return !seenPriority.has(p.id); });

          /* Insérer les prioritaires en premier */
          filtered = priorityProducts.concat(filtered);
        }
      }

      totalPages = Math.ceil(filtered.length / pageSize);

      if (filtered.length === 0) {
        if (m) { m.style.display = 'none'; m.removeAttribute('data-visible'); }
        stopRot(); return;
      }

      if (!m) {
        log('Module not found, retry 500ms');
        setTimeout(function () { var m2 = findModule(); if (m2) populateModule(m2, remaining); }, 500);
        return;
      }

      populateModule(m, remaining);
    })
    .catch(function (err) { log('update error:', err); });
  }

  function populateModule(m, remaining) {
    if (filtered.length === 0) return;

    var newIds = filtered.map(function (p) { return p.id; }).join(',');
    var newMode = remaining <= 0 ? 'goodies' : 'shipping';

    /* Vérifier si le module a réellement du contenu affiché.
       Si le products container est vide, on FORCE le re-render
       même si data-visible est true (= stale ancien module). */
    var cont = m.querySelector('.bro-cs__products');
    var hasCards = cont && cont.querySelector('.bro-cs__card');
    var isVisible = m.style.display !== 'none' && hasCards;

    var needsRender = !isVisible
      || m.getAttribute('data-filtered-ids') !== newIds
      || m.getAttribute('data-mode') !== newMode
      || m.getAttribute('data-page-size') !== String(pageSize);

    log('populateModule: needsRender=' + needsRender, 'isVisible=' + isVisible, 'hasCards=' + !!hasCards, 'display=' + m.style.display);

    if (!needsRender) return;

    if (!cont) {
      log('Rebuilding inner HTML');
      m.innerHTML = '<div class="bro-cs__inner"><div class="bro-cs__header"><span class="bro-cs__badge">\uD83C\uDFAF</span><span class="bro-cs__title"></span><span class="bro-cs__urgency"></span></div><div class="bro-cs__products"></div><div class="bro-cs__nav"></div><div class="bro-cs__dots"></div></div>';
      cont = m.querySelector('.bro-cs__products');
    }
    if (!cont) return;

    updateHeader(m, newMode);
    currentPage = 0;
    totalPages = Math.ceil(filtered.length / pageSize);
    renderPage(cont, null); renderNav(m); renderDots(m); initSwipe(m);

    m.style.display = ''; m.style.opacity = ''; m.style.transform = '';
    m.setAttribute('data-visible', 'true');
    m.setAttribute('data-filtered-ids', newIds);
    m.setAttribute('data-mode', newMode);
    m.setAttribute('data-page-size', String(pageSize));

    if (totalPages > 1) startRot();
    m.onmouseenter = stopRot;
    m.onmouseleave = function () { if (totalPages > 1) startRot(); };

    log('Populated OK!', filtered.length, 'products,', totalPages, 'pages');
  }

  var timer = null;
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(update, delay || 700); }

  /* ---- LISTENERS ---- */
  try { if (sessionStorage.getItem('bro_cs_reopen') === '1') { sessionStorage.removeItem('bro_cs_reopen'); setTimeout(function () { var b = document.querySelector('[data-cart-toggle]') || document.querySelector('.navlink--cart'); if (b) b.click(); }, 500); } } catch (e) {}
  try { if (sessionStorage.getItem('bro_reopen_drawer') === '1') { sessionStorage.removeItem('bro_reopen_drawer'); setTimeout(function () { var cd = document.querySelector('cart-drawer'); if (cd && typeof cd.openCartDrawer === 'function') { try { cd.openCartDrawer(); } catch (e) {} } else { var b = document.querySelector('[data-cart-toggle]') || document.querySelector('.navlink--cart'); if (b) b.click(); } }, 600); } } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(300); });
  else schedule(300);

  ['cart:refresh', 'cart:change', 'variant:add', 'line-item:change'].forEach(function (evt) {
    function h() { log('Event:', evt); schedule(400); setTimeout(function () { schedule(200); }, 800); setTimeout(function () { schedule(200); }, 1500); }
    document.addEventListener(evt, h); document.documentElement.addEventListener(evt, h);
  });

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0], urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      var result = origFetch.apply(this, arguments);
      if (urlStr.indexOf('/cart/change') !== -1 || urlStr.indexOf('/cart/update') !== -1 || urlStr.indexOf('/cart/add') !== -1) {
        log('Intercepted fetch:', urlStr);
        result.then(function () {
          setTimeout(function () { schedule(300); }, 500);
          setTimeout(function () { schedule(200); }, 1200);
          setTimeout(function () { schedule(200); }, 2000);
        }).catch(function () {});
      }
      return result;
    };
  }

  /* Watch BODY instead of just the drawer — catches drawer destroy+recreate */
  var bodyObsTimer;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var target = muts[i].target;
      if (target && (target.id === 'bro-cross-sell' || (target.closest && target.closest('#bro-cross-sell')))) continue;
      var added = Array.from(muts[i].addedNodes);
      for (var j = 0; j < added.length; j++) {
        if (added[j].id === 'bro-cross-sell' || added[j].id === 'cart-drawer' ||
            (added[j].querySelector && (added[j].querySelector('#bro-cross-sell') || added[j].querySelector('#cart-drawer')))) {
          log('BodyObs: cart-drawer or #bro-cross-sell added');
          clearTimeout(bodyObsTimer);
          bodyObsTimer = setTimeout(function () { schedule(100); }, 50);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* Cart page watchers */
  if (document.querySelector('[data-cart-page]')) {
    (function () {
      var ot;
      function onM(muts) {
        for (var i = 0; i < muts.length; i++) { var a = Array.from(muts[i].addedNodes); for (var j = 0; j < a.length; j++) { if (a[j].id === 'bro-cross-sell' || (a[j].querySelector && a[j].querySelector('#bro-cross-sell'))) { clearTimeout(ot); ot = setTimeout(function () { schedule(100); }, 50); return; } } }
        clearTimeout(ot); ot = setTimeout(function () { schedule(300); }, 200);
      }
      var a = document.querySelector('[data-checkout-buttons]'); if (a) new MutationObserver(onM).observe(a, { childList: true, subtree: true });
      var f = document.querySelector('form[action="/cart"]'); if (f) new MutationObserver(onM).observe(f, { childList: true, subtree: true, characterData: true, attributes: true });
      var p = document.querySelector('[data-cart-price-holder]'); if (p) new MutationObserver(onM).observe(p, { childList: true, subtree: true, characterData: true });
    })();
    var _lcs = null;
    setInterval(function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
        var s = d.total_price + '|' + d.item_count + '|' + d.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        if ((_lcs !== null && _lcs !== s) || (!document.querySelector('#bro-cross-sell[data-visible]') && d.items.length > 0)) schedule(300);
        _lcs = s;
      }).catch(function () {});
    }, 1500);
  }

  /* Drawer polling */
  var _lds = null;
  setInterval(function () {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    var isOpen = drawer.classList.contains('is-open') || drawer.hasAttribute('open') || drawer.closest('.is-open') || getComputedStyle(drawer).visibility === 'visible';
    if (!isOpen) return;
    var m = findModule();
    var cont = m ? m.querySelector('.bro-cs__products') : null;
    var hasCards = cont && cont.querySelector('.bro-cs__card');
    if (m && (!hasCards || m.style.display === 'none')) {
      log('Polling: module empty or hidden → schedule');
      schedule(200);
      return;
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
      var s = d.total_price + '|' + d.item_count + '|' + d.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      if ((_lds !== null && _lds !== s) || (d.items.length > 0 && (!m || !hasCards))) { log('Polling: changed → schedule'); schedule(300); }
      _lds = s;
    }).catch(function () {});
  }, 1000);

})();